import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faStroopwafel,
  faArrowRight,
  faArrowLeft,
  faSearch,
  faTimes,
  faPlus,
  faPaperPlane,
  faFileDownload,
  faTrash
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faStroopwafel,
  faArrowLeft,
  faArrowRight,
  faSearch,
  faTimes,
  faPlus,
  faPaperPlane,
  faFileDownload,
  faTrash
)
